// Copyright 2022 - 2023 Fewcha. All rights reserved.

import React from "react";

const Footer: React.FC = () => {
  return (
    <footer
      className="flex justify-between items-center py-7 max-w-[1232px] mx-auto w-full px-6 xl:px-0 text-white"
      id="footer"
    >
      © Copyright Fewcha 2022
    </footer>
  );
};

export default Footer;
